export default "__VITE_ASSET__BGhCOWuw__"